var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Aktualno\\u015Bci",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tablet---Dashboard",
    transform: "translate(-425.000000, -2537.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(25.000000, 2156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crosshair",
    transform: "translate(400.000000, 381.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#D1D1D3",
    strokeWidth: 2,
    cx: 20,
    cy: 19.9833333,
    r: 14.1666667
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 5.83333333,
    x2: 20,
    y2: -1.56319402e-13,
    id: "Path",
    stroke: "#D1D1D3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 40,
    x2: 20,
    y2: 34.1666667,
    id: "Path",
    stroke: "#D1D1D3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.1666667,
    y1: 20,
    x2: 40,
    y2: 20,
    id: "Path",
    stroke: "#D1D1D3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 20,
    x2: 5.83333333,
    y2: 20,
    id: "Path",
    stroke: "#D1D1D3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#D1D1D3",
    fillRule: "nonzero",
    cx: 20,
    cy: 20,
    r: 2.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.e08fc1dd44e8675f65ef39c6f167e105.svg";
export { ForwardRef as ReactComponent };